import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function StoryCard({ story, featured = false }) {
  const { lang, t } = useApp();
  return (
    <Link
      to={`/stories/${story.slug}`}
      className={`story-card glass-card ${featured ? "featured" : ""}`}
      data-testid={`story-card-${story.slug}`}
    >
      <div className="story-card-img">
        <img src={story.cover_image} alt={story[`title_${lang}`]} loading="lazy" />
      </div>
      <div className="story-card-body">
        <div className="story-meta">
          <span>{new Date(story.published_at).toLocaleDateString(lang === "ar" ? "ar-SA" : "en-GB", { year: "numeric", month: "long", day: "numeric" })}</span>
          <span className="story-dot" />
          <span><Clock size={12} /> {story.read_minutes} {t("stories.min")}</span>
        </div>
        <h3 className="story-card-title">{story[`title_${lang}`]}</h3>
        <p className="story-card-excerpt">{story[`excerpt_${lang}`]}</p>
      </div>
    </Link>
  );
}
